import React, { useEffect, useState } from "react";
import { useParams } from 'react-router';
import { useTranslation } from "react-i18next";
import i18next from 'i18next';
import styled from 'styled-components';
import { Row, Col, Button, Flex } from 'antd';
import query from "../../../../server/constants.api";
import useFetch from "../../../../server/useFetch";
import { Text } from "../../Atomics/Text";
import CustomIcon from "../../Icons/CustomIcon";
import { Field } from "../../../../styles/global/Pages.styled";
import { RegisterMap } from "../Maps/RegisterMap";

const MapWrapper = styled.div`
    height: 200px;
`;

export const RegisterData = ({hasRegisterDetail}) => {

  const { t } = useTranslation();
  const { id } = useParams();

  const [rgData, setRgData] = useState(null);
  const [latitude, setLatitude] = useState();
  const [longitude, setLongitude] = useState();

  const { data: registryDetailData, isLoading: registryDetailLoading, refetch: refetchRegistryDetail, error: registryDetailDataError } = useFetch(query.path.registryDetail, 'getRegistryDetail', { id: id, language: i18next.resolvedLanguage });

  useEffect(() => {
    if (registryDetailData?.data) {
      setRgData(registryDetailData?.data);
      hasRegisterDetail(registryDetailData?.data)
    } else if (registryDetailDataError) {
      console.error('(Register detail page) Register detail data: Error in useEffect setting detail data:', registryDetailDataError);
    }

  }, [registryDetailData, registryDetailDataError]);

  useEffect(() => {
    if (rgData?.data) {
      rgData?.data?.map((el) => {
        if (el.id === 'latitude') {
          setLatitude(el.value)
        } else if (el.id === 'longitude') {
          setLongitude(el.value)
        }
      })
    }
  }, [rgData]);

  const [showMore, setShowMore] = useState(false);
  const hideData = () => {
    setShowMore(false);
  }
  const showData = () => {
    setShowMore(true);
  }
  return (
    <Row gutter={[16, 16]}>
      <Col span={16}>
        <Row gutter={[16, 16]}>
          {rgData?.data?.map((item, index) => (
            index < 6 ?
              <Col span={12} key={index} className='d-flex'>
                <Field id={item?.id} $backgroundColor="neutral-3" className='full-width'>
                  <Text $fontColor='coolgray-10' $fontSize='text_xs' $weight='regular'>{item?.label}</Text>
                  <Text $fontColor='coolgray-12' $fontSize='text_md' $weight='regular'>{item?.value && item?.value != '' ? item?.value : '-'}</Text>
                </Field>
              </Col>
              : (showMore ?
                <Col span={12} key={index} className='d-flex'>
                  <Field id={item?.id} $backgroundColor="neutral-3" className='full-width'>
                    <Text $fontColor='coolgray-10' $fontSize='text_xs' $weight='regular'>{item?.label}</Text>
                    <Text $fontColor='coolgray-12' $fontSize='text_md' $weight='regular'>{item?.value ?? '-'}</Text>
                  </Field>
                </Col>
                : null)
          ))}
          {rgData?.data?.length > 6 ?
            < Col span={24} >
              {showMore
                ? <Flex align="center" justify="center"><Button className='ant-btn-link' type="link" onClick={hideData}><Flex align="center" justify="center"><Text $fontColor='blue-4' $fontSize='text_md' $weight='medium' $marginRight="s03">{t('seeLess')}</Text>  <CustomIcon icon={'ChevronUp'} iconsize='sm' color='blue-4' /></Flex></Button></Flex>
                : <Flex align="center" justify="center"><Button type="link" onClick={showData}><Flex align="center" justify="center"><Text $fontColor='blue-4' $fontSize='text_md' $weight='medium' $marginRight="s03">{t('seeMore')}</Text>  <CustomIcon icon={'ChevronDown'} iconsize='sm' color='blue-4' /></Flex></Button></Flex>
              }
            </Col> : null
          }

        </Row>
      </Col>
      <Col span={8}>
        <Flex gap={16} vertical="true">
          <MapWrapper>
            <RegisterMap itemsIds={[id]} idQuery='RegisterDetail' idCenter={{ lat: parseFloat(latitude), lng: parseFloat(longitude) }} idZoom={17} mapId={'e1816747e3cd86e6'} disableClick={true} />
          </MapWrapper>
        </Flex>
      </Col>
    </Row>
  )
}